/* unplugin-vue-components disabled */import script from "./setting.vue?vue&type=script&setup=true&lang=ts"
export * from "./setting.vue?vue&type=script&setup=true&lang=ts"

import "./setting.vue?vue&type=style&index=0&id=7aaaf48e&lang=scss&scoped=true"

import exportComponent from "E:\\aodong\\work\\plus\\aodong-system-web-plus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aaaf48e"]])

export default __exports__